import featureLibraryReducer from '@features/featureLibrary/featureLibrarySlice';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { cashManagementApi } from 'api/cash-management.api';
import { clientApi } from '../api/client.api';
import { locationApi } from '../api/location.api';
import { parameterApi } from '../api/parameter.api';
import { roleApi } from '../api/role.api';
import { sessionApi } from '../api/session.api';
import { tenantApi } from '../api/tenant.api';
import { userApi } from '../api/user.api';
import clientReducer from '../features/client/clientSlice';
import locationReducer from '../features/location/locationSlice';
import notificationReducer from '../features/notification/notificationSlice';
import roleReducer from '../features/role/roleSlice';
import sessionReducer from '../features/session/sessionSlice';
import tenantReducer from '../features/tenant/tenantSlice';
import userReducer from '../features/user/userSlice';
import uxReducer from '../features/ux/uxSlice';
import { httpErrorMiddleware } from './httpErrorMiddleware';
import { referenceListApi } from 'api/reference-list.api';

const store = configureStore({
  reducer: {
    session: sessionReducer,
    user: userReducer,
    client: clientReducer,
    role: roleReducer,
    location: locationReducer,
    tenant: tenantReducer,
    notification: notificationReducer,
    ux: uxReducer,
    featureLibrary: featureLibraryReducer,
    [tenantApi.reducerPath]: tenantApi.reducer,
    [sessionApi.reducerPath]: sessionApi.reducer,
    [parameterApi.reducerPath]: parameterApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [locationApi.reducerPath]: locationApi.reducer,
    [cashManagementApi.reducerPath]: cashManagementApi.reducer,
    [referenceListApi.reducerPath]: referenceListApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      httpErrorMiddleware,
      tenantApi.middleware,
      sessionApi.middleware,
      parameterApi.middleware,
      clientApi.middleware,
      userApi.middleware,
      roleApi.middleware,
      locationApi.middleware,
      cashManagementApi.middleware,
      referenceListApi.middleware,
    ),
});

// Add setup listener for RTK Query
setupListeners(store.dispatch);

export default store;
